import { ExperimentKeys } from '../../experiments/ExperimentKeys';
import { ExperimentParameterGroup } from '../../experiments/ExperimentParameterGroup';
import { EndpointKey } from '../../http/EndpointKey';
import { getIsActiveAndAssignedToVariant } from '../../store/experiments/selectors';
import { isEligibleForACQ177ProductisedFlow } from './isEligibleForACQ177ProductisedFlow';
import { isProductisedSignupFlow } from './isProductisedSignupFlow';
export const getGTKMEndpointKey = state => {
  const isACQ177Active = isEligibleForACQ177ProductisedFlow(state) || getIsActiveAndAssignedToVariant(state, ExperimentKeys.ACQ0177, [ExperimentParameterGroup.Variant_A]);
  if (isProductisedSignupFlow(state)) {
    return EndpointKey.GTKMCompanyInfoSU0004;
  }
  if (isACQ177Active) {
    return EndpointKey.GTKMCompanyInfoACQ177;
  }
  return EndpointKey.GTKMCompanyInfo;
};